<template>
  <div class="oneMachine">
    <div class="banner">
      <img
        class="banner_bg"
        src="@/assets/images/oneMachine/ym_banner.png"
        alt=""
      />
      <div class="banner_container">
        <div class="banner_content">
          <img src="@/assets/images/oneMachine/title.png" alt />
          <img src="@/assets/images/oneMachine/ym_banner_small.png" alt="" />
          <img  class="bg_right" src="@/assets/images/oneMachine/ym_banner_right.png" alt="" />
        </div>
      </div>
    </div>
    <div class="main">
      <!-- 简介 -->
      <div class="introduction">
        <img
          class="introduction_bg"
          src="@/assets/images/oneMachine/introduction.png"
          alt=""
        />
        <div>
          <div class="title" style="margin-top:50px;">简介</div>
          <div class="info text" style="width:980px">
            云幕门店屏幕管理系统，致力于为客户提供功能更全面、成本更可控、
            操作更便捷的门店营销方案,迄今我们的产品已服务于众多标杆品牌客户
          </div>
        </div>
        <img
          style="vertical-align:bottom;display:inline-block;z-index:1;"
          src="@/assets/images/oneMachine/introduction-info.png"
          alt=""
        />
      </div>
      <!-- 功能介绍 -->
      <div class="item">
        <div class="function_container">
          <div class="title" style="margin-top:160px;">功能介绍</div>
          <div
            class="function_introduction_list"
            style="display:flex;margin-top:50px"
          >
            <div class="function_introduction_content">
              <div
                class="function_introduction_item"
                @mouseenter.stop="show1 = !show1"
                @mouseleave.stop="show1 = !show1"
              >
                <div
                   class="function_introduction_item1"
                >
                  <img src="@/assets/images/oneMachine/function1.png" alt="" />
                  <div>更全面的营销手段</div>
                </div>
                <transition name="lc">
                  <div class="function_introduction_item2" v-if="show1">
                    <div class="function_item2_top">
                      <img
                        src="@/assets/images/oneMachine/function1.png"
                        alt=""
                      />
                      <div class="function_item2_title">更全面的营销手段</div>
                    </div>
                    <div class="function_item2_text">
                      通过云幕,总部可以集中向所有门店屏幕下发图片、视频、音频、H5、文本等,轻松实现分屏、多屏联动，横排、竖排甚至异形拼接,结合需要，还可以整合音频播放、叫号系统等，实现设备的最大化利用，解锁更多交互方式
                    </div>
                  </div>
                </transition>
              </div>
              <div
                class="function_introduction_item"
                @mouseenter.stop="show2 = !show2"
                @mouseleave.stop="show2 = !show2"
              >
                <div
                  class="function_introduction_item1"
                >
                  <img src="@/assets/images/oneMachine/function2.png" alt="" />
                  <div>更便捷的集中管控</div>
                </div>
                <transition name="lc">
                  <div class="function_introduction_item2" v-if="show2">
                    <div class="function_item2_top">
                      <img
                        src="@/assets/images/oneMachine/function2.png"
                        alt=""
                      />
                      <div class="function_item2_title">更便捷的集中管控</div>
                    </div>
                    <div class="function_item2_text">
                      基于SaaS平台，总部只需一个账号即可管理全国门店，极大提高运营效率；并且可以按营销节点、节日、时段设置播放内容，到期自动播放；此外，云幕还支持为特定区域的门店、不同屏幕个数的门店设置对应节目，满足多样化运营需求
                    </div>
                  </div>
                </transition>
              </div>
              <div
                class="function_introduction_item"
                @mouseenter.stop="show3 = !show3"
                @mouseleave.stop="show3 = !show3"
              >
                <div class="function_introduction_item1">
                  <img src="@/assets/images/oneMachine/function3.png" alt="" />
                  <div>更完善的落地方案</div>
                </div>
                <transition name="lc">
                  <div class="function_introduction_item2" v-if="show3">
                    <div class="function_item2_top">
                      <img
                        src="@/assets/images/oneMachine/function3.png"
                        alt=""
                      />
                      <div class="function_item2_title">更完善的落地方案</div>
                    </div>
                    <div class="function_item2_text">
                      云幕支持主流品牌电视通过应用商店下载安装；LED屏及非智能电视可连接盒子，即装即用，有效控制成本；硬件方面，云幕桌面屏、广告一体机、高亮屏等可供选择；此外，云幕提供免费培训及专属客服实时线上服务，助力门店运营人员快速上手，降本增效
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>    
          <!-- 动画部分 -->
          <div class="motions">
            <div class="motions_container">
              <div class="motions_defaults" v-if="!(show1 || show2 || show3)">
                <img src="@/assets/images/oneMachine/complex_good.png" />
              </div>

              <div class="motions_defaults" v-else>
                <img src="@/assets/images/oneMachine/complex_good_slur.png" />
                 <div class="motions_function_item1" v-if="show2">
                    <img src="@/assets/images/oneMachine/function_default1.png" />
                 </div>
                 <div class="motions_function_item2" v-if="show3">
                    <img src="@/assets/images/oneMachine/wave2_tv.png" />
                 </div>
                <div class="motions_function_item3" v-if="show1" >
                    <img src="@/assets/images/oneMachine/wave_semicircle.png" />
                    <img src="@/assets/images/oneMachine/complex_good.png" />
                    <img src="@/assets/images/oneMachine/wave_icon1.png" />
                    <img src="@/assets/images/oneMachine/wave_icon2.png" />
                    <img src="@/assets/images/oneMachine/wave_icon3.png" />
                    <img src="@/assets/images/oneMachine/wave_icon4.png" />
                    <img src="@/assets/images/oneMachine/wave_icon5.png" />
                    <img src="@/assets/images/oneMachine/wave_icon6.png" />
                    <img src="@/assets/images/oneMachine/wave_icon7.png" />
                 </div> 

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 硬件配套 -->
      <div class="item">
        <div class="hardware_container">
          <div class="title" style="margin-top:160px;margin-bottom:30px">
            硬件配套
          </div>
          <div class="hardware_text">一线品牌电视</div>
          <div class="hardware_TV">
            <div class="hardware_TV_item">
              <img src="@/assets/images/oneMachine/hardware_icon1.png" alt="" />
              <div>
                小米/TCL/海信/创维等一线品牌厂商,具有大批量生产能力和强大的物流、售后体系，购买成本以及售后成本更低
              </div>
            </div>
            <div class="hardware_TV_item">
              <img src="@/assets/images/oneMachine/hardware_icon2.png" alt="" />
              <div>
                通过和小米/TCL/海信等厂商合作，可以方便的从应用市场获得云幕应用，定制版支持出厂预置云幕
              </div>
            </div>
          </div>
          <div class="hardware_type">
            <div class="hardware_type_item">
              <div>
                <img
                  src="@/assets/images/oneMachine/highlight_screen.png"
                  alt=""
                />
              </div>

              <div>高亮屏</div>
            </div>
            <div class="hardware_type_item">
              <div>
                <img
                  src="@/assets/images/oneMachine/desktop_screen.png"
                  alt=""
                />
              </div>
              <div>桌面屏</div>
            </div>
            <div class="hardware_type_item">
              <div>
                <img src="@/assets/images/oneMachine/other_type.png" alt="" />
              </div>
              <div>其他设备</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 标杆品牌认证 -->
      <div class="item">
        <div class="brand_container">
          <div class="title" style="margin-top:160px;margin-bottom:150px">
            标杆品牌认证
          </div>
          <div class="brand_container_content">
            <div class="brand_container_item">
              <img src="@/assets/images/oneMachine/brand1.png" alt="" />
              <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon1.png" alt="">
                    <div class="icon_title">蜜雪冰城</div>
                    <div class="icon_text">
                       蜜雪冰城总部管控20000＋门店，与云幕深度合作，数智化升级引领行业变革
                    </div>
                </div>
            </div>
            <div class="brand_container_item">
              <img src="@/assets/images/oneMachine/brand2.png" alt="" />
               <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon7.png" alt="">
                    <div class="icon_title">泸溪河</div>
                    <div class="icon_text">
                        国民糕点品牌泸溪河，门店全面部署云幕管理系统，创造新的智慧营销
                    </div>
                </div>
            </div>
            <div class="brand_container_item">
                <img src="@/assets/images/oneMachine/brand3.png" alt="" />
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon17.png" alt="">
                    <div class="icon_title">杜肯集团</div>
                    <div class="icon_text">
                        制造业龙头企业杜肯集团，携手云幕持续创新，拥抱智能工业快速发展
                    </div>
                </div>
            </div>
            <div class="brand_container_item">
              <img src="@/assets/images/oneMachine/brand4.png" alt="" />
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon8.png" alt="">
                    <div class="icon_title">鱼你在一起</div>
                    <div class="icon_text">
                        中国餐饮品牌百强鱼你在一起，通过云幕管理差异化运营，打造千店千面
                    </div>
                </div>
            </div>
            <div class="brand_container_item">
              <img src="@/assets/images/oneMachine/brand5.png" alt="" />
                <div class="container_bg">
                    <img class="icon_img" src="@/assets/images/customerCase/icon16.png" alt="">
                    <div class="icon_title">芙鹿家便利店</div>
                    <div class="icon_text">
                        连锁便利店芙鹿家，以屏幕为触点，实现多元化营销，提升多维度竞争力
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 更多客户案例 -->
      <div class="add">
        <router-link class="btn" tag="div" to="/CustomerCase"
          >更多客户案例</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //功能介绍切换
      show1: false,
      show2: false,
      show3: false
    };
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
/* 首屏背景 */
.banner_bg {
  height: 700px;
  width:100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -3;
}
.banner {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 700px;
  background-size: 100%;
}
.banner_container {
  width: 1200px;
  height: 700px;
  margin: 0 auto;
}
.banner_content {
  width: 1200px;
  height: 700px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner_content .bg_right{
  position:absolute;
  top:0;
  right:0;
  z-index: -2;
}
.banner .left {
  z-index: 1;
  width: 30%;
  max-width: 575px;
}
.banner .right {
  z-index: 1;
  margin-left: 65px;
  width: 26%;
}
.banner .right img {
  width: 554px;
  height: 414px;
}
.main {
  margin-bottom: 100px;
}
/* 简介 */
.introduction {
  height: 712px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  background-size: 100%;
  position: relative;
}
.introduction_bg {
  position: absolute;
  top: 0;
  right: 0;
  height: 712px;
  width:100%;
}
.title {
  font-size: 50px;
  margin-bottom: 30px;
  font-weight: 600;
  text-align: center;
}
.info {
  margin: 0 auto;
}
.text {
  color: #3b436b;
  font-size: 22px;
}
/* 功能介绍 */
.function_container,
.motions_container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}
.function_introduction_content {
  z-index: 1;
  width: 1200px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.function_introduction_item {
  width: 400px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.function_introduction_item1 {
  position: relative;
  width: 400px;
  height: 185px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.function_introduction_item2 {
  width: 400px;
  height: 247px;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 28px;
}
.function_item2_top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 28px;
  border-bottom: 1px solid #efeff0;
  margin-bottom: 28px;
  padding: 12px 0 46px 0;
}
.function_introduction_item2 img {
  width: 48px;
}
.function_introduction_item2 .function_item2_title {
  height: 26px;
  font-size: 26px;
  font-weight: 400;
  text-align: left;
  color: #2c3254;
  line-height: 26px;
}
.function_introduction_item2 .function_item2_text {
  height: 99px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #75798c;
  line-height: 20px;
}
.lc-enter,
.lc-leave-to {
  opacity: 0;
}
.lc-enter-to,
.lc-leave {
  opacity: 1;
}
.lc-enter-active,
.lc-leave-active {
  transition: all 1s;
}
/* 功能介绍动画部分 */
.motions {
  height: 450px;
  width: 100%;
}
.motions_container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  position: relative;
  top: 120px;
}
.motions_defaults{
    border-color: #26bbff;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}
/* 点击第一个*/
.motions_function_item1 {
  width: auto;
  position: absolute;
  left:25%;
  z-index: 999;
  transform: scale(1.1);
  animation: scaleAnimation 0.5s linear;
}
/* 点击第二个 */
.motions_function_item2 {
  width: auto;
  position: absolute;
  left:20%;
  z-index: 999;
  transform: scale(1.1);
  animation: scaleAnimation 0.5s linear;
}
/* 点击第三个 */
.motions_function_item3 {
  width: 1200px;
  position: absolute;
  left:20%;
  z-index: 999;
}
.motions_function_item3 img:nth-of-type(1) {
  position: absolute;
  height: 430px;
  bottom:0;
  left: -5%;
  transform: rotate(180);
  z-index: 9999;
  opacity: 0.8;
  animation: scaleAnimation 1s linear infinite alternate;
}
.motions_function_item3 img:nth-of-type(2) {
  position: absolute;
  bottom:0;
  left:0;
  transform: scale(1.1);
}
/* 小图标 */
.motions_function_item3 img:nth-of-type(3) {
  position: absolute;
  bottom: 20px;
  left: -10%;
  animation: translateAnimation1 1s linear infinite alternate;
}
.motions_function_item3 img:nth-of-type(4) {
  position: absolute;
  bottom: 240px;
  left: -4%;
  animation: translateAnimation2 1s linear infinite alternate;
}
.motions_function_item3 img:nth-of-type(5) {
  position: absolute;
  bottom: 380px;
  left: 10%;
  animation: translateAnimation1 1s linear infinite alternate;

}
.motions_function_item3 img:nth-of-type(6) {
  position: absolute;
  width:60px;
  bottom: 420px;
  left: 26%;
  animation: translateAnimation2 1s linear infinite alternate;

}
.motions_function_item3 img:nth-of-type(7) {
  position: absolute;
  bottom: 380px;
  left: 40%;
  animation: translateAnimation1 1s linear infinite alternate;

}
 .motions_function_item3 img:nth-of-type(8){
  position: absolute;
  bottom: 270px;
  left: 58%;
  animation: translateAnimation2 1s linear infinite alternate;
}
.motions_function_item3 img:nth-of-type(9) {
  position: absolute;
  bottom: 20px;
  left: 65%;
  animation: translateAnimation1 1s linear infinite alternate;

} 
/* 硬件配套 */
.hardware_container,
.brand_container {
  width: 1200px;
  height: auto;    
  margin: 0 auto;
}
.hardware_text {
  height: 30px;
  font-size: 22px;
  font-weight: 400;
  height: 30px;
  text-align: center;
  color: #3b436b;
  line-height: 30px;
}
.hardware_TV {
  width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 40px;
}
.hardware_TV_item {
  width: 50%;
  padding: 0 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.hardware_TV_item img {
  margin: 20px 0;
}
.hardware_TV_item div {
  height: 65px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #3b436b;
  line-height: 20px;
}
.hardware_type,
.brand_container_content {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hardware_type_item {
  width: 360px;
  height: 376px;
  border: 1px solid #abb6c5;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-right: 6px;
}
.hardware_type_item div:nth-child(1) {
  width: 358px;
  height: 270px;
  border-top: 1px solid #f9fbff;
  border-radius: 4px;
  background-color: #f9fbff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hardware_type_item img {
  width: 359px;
}
.hardware_type_item div:nth-child(2) {
  width: 360px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  color: #3b436b;
  line-height: 22px;
}
/* 标杆品牌认证 */
.brand_container_item {
  width: 224px;
  height: 350px;
  background: #ffffff;
  border-radius: 100px 100px 0px 0px 0px 0px 0px 0px 0px 0px 100px 100px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  position:relative;
}
.container_bg{
  position: absolute;
  bottom:0;
  left:0;
  width: 224px;
  height: 185px;
  background: url('~@/assets/images/oneMachine/container_bg.png');
}
.icon_img {
    position: absolute;
    top: 5px;
    left: 35px;
    width: 20px;
}
.icon_title {
  padding: 20px;
  height: 30px;
  font-size: 22px;
  font-weight: 400;
  text-align: left;
  color: #3b436b;
  line-height: 30px;
  margin: 28px 0 10px 0;
}
.icon_text {
  padding: 20px;
  height: 100px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #75798c;
  line-height: 20px;
  letter-spacing: 0.5px;
}
/* 查看更多案例 */
.add {
  width: 1200px;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;
}

.add .btn {
  display: inline-block;
  width: 156px;
  height: 54px;
  background: #26bbff;
  border-radius: 2px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  line-height: 54px;
}

/* 动画 */
@keyframes scaleAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1.1);
  }
}
/* 动画 */
@keyframes translateAnimation1 {
    0% {
        transform: translate(0,0);
    }
    100% {
        transform: translate(20px,20px);
    }
}
@keyframes translateAnimation2 {
    0% {
        transform: translate(20px,20px);
    }
    100% {
        transform: translate(0,0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/oneMachine.vue